import { useContext, useEffect, useState } from "react";
import ManualBet from "../../components/UI/Manual_bet/ManualBet";
import styles from "./Auction.module.css"
import styles_wheel from "../Wheel/SimpleRoulete.module.css"
import { Context } from "../..";
import formatCurrency from "../../Utils/formatCurrency";
import Timer from "../../components/UI/Timer/Timer";
import Table from "../../components/UI/Table/Table"
import ErrorComponent from "../../components/UI/Error/ErrorComponent";
import AuctionService from "../../service/AuctionService"
import SpinLoad from "../../components/UI/Spin/Spin";
import InfUser from "./components/infUser/InfUser";
import { Carousel, ConfigProvider, Spin } from "antd";
import Footer from "../../components/Footer/Footer";
import { unpack } from "../../Utils/forSocket";
import { mainSchema } from "../../Utils/NAME_HOST";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/Modals/Modal";
import History from "./components/History/History";
import { fillTextPage } from "../../Utils/FillTextPage";
import Sound_play from "../../Utils/sound_play";
import { succses_bet } from "../../Utils/sounds";
function Auction() {
    const navigate = useNavigate();
    const { store } = useContext(Context);
    const ButtonsChoiceFastSum = [20, 100, 500, 1000]
    const [indexSelectedButtonsSum, setIndexSelectedButtonsSum] = useState(0)
    const [amount_lose, setAmount_lose] = useState(0)
    const [amount_win, setAmount_win] = useState(0)
    const [user_card, setUser_card] = useState({})
    const [load_buttonBet, setLoad_buttonBet] = useState(false)
    const [users_lose, setUsers_lose] = useState([])
    const [users_win, setUsers_win] = useState([])
    const [load_state, setLoad_state] = useState(true)
    const [history_auction, setHistory_auction] = useState([])
    const [stateBlockWin, setStateBlockWin] = useState(false)
    const [modal_state, setModal_state] = useState(false)
    const [amount, setAmount] = useState(null);
    function countDatasWin() {
        const all_bets = [...users_lose, ...users_win]
        all_bets.push({ amount })

    }
    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    async function bet() {
        try {
            Sound_play(succses_bet,store.sound)
            if (!load_buttonBet) {
                setLoad_buttonBet(true)
                if (amount > 0) {
                    const response = await AuctionService.bet(amount)
                    if (response.data.status === 0) {
                        // store.add_message(response.data.err, ErrorComponent)
                        navigate("/pay")
                    }
                    if (response.data.status === 1) {
                        
                        window.location.reload()
                    }
                }
            }

        }
        catch (e) {
            store.add_message("error1", ErrorComponent)

        }
        finally {
            setLoad_buttonBet(false)
        }
    }
    async function fillDataAuction(state) {
        try {
            const response_get_bets = await AuctionService.get_bets();

            if (response_get_bets.data.status === 1) {

                const data = response_get_bets.data.data;

                const { amount_lose, amount_win, user_card, users_lose, users_win, second } = data;

                setAmount_lose(amount_lose)
                setAmount_win(amount_win)
                setUsers_lose(users_lose)
                setUsers_win(users_win)

                if (state === "start") {

                    store.set_time_auction(second);

                    setUser_card(user_card)

                    setHistory_auction(data.auction_history)

                    setLoad_state(false)
                    const interval = setInterval(async () => {
                        await fillDataAuction("interval");
                    }, 5000)




                }
                


            }
            else{
                store.set_modal("unreg")
            }
        } catch (e) {
            store.add_message("error1", ErrorComponent)
        }
    }
    async function start() {
        fillTextPage("auction", store)
        fillDataAuction("start");
            
        



    }
    // useEffect(() => {
    //     if (!load_state) {
    //         setStateBlockWin(true)
    //     }
    // }, [amount])

    useEffect(() => {
        if (store.time_auction <= 0) {
            window.location.reload()
        }
    }, [store.time_auction])
    useEffect(() => {

        start()
    }, [])
    

    return (<>
        <Modal ModelState={modal_state} setModelState={setModal_state} Component={History} props={{ history_auction }} />
        {load_state ? <SpinLoad /> : (
            <>
            <div className={`${styles.main} fadeAnimationMain`}>

                {/*<div className={styles.header}>Аукцион</div>*/}

                {store.isPhone ? (
                    <div className={styles.rules}>
                        <div className={styles.rule}>
                            Больше поставил <i class="fa-solid fa-arrow-right"></i> Забрал профит
                        </div>
                        <div className={styles.line_block}></div>
                        <div className={styles.rule} style={{ flexDirection: "column" }}>
                            <p>Победители делят сумму всех ставок</p>
                            <div className={styles.line_block}></div>
                            <p>10% Участников проигрывают</p>
                        </div>
                        <div className={styles.line_block}></div>
                        <div className={styles.rule}>
                            До конца аукциона можно повышать ставку сколько угодно раз
                        </div>
                    </div>
                ) : (
                    <div className={styles.rules}>
                        <div className={styles.rule}>Больше поставил <i class="fa-solid fa-arrow-right"></i> Забрал профит</div>
                        <div className={styles.rule} style={{ flexDirection: "column" }}><p>Победители делят сумму всех ставок</p><br /><p>10% Участников проигрывают</p></div>
                        <div className={styles.rule}>До конца аукциона можно повышать ставку сколько угодно раз</div>
                    </div>

                )}






                <div className={styles.containerManager}>
                    <div className={styles.blockHistoryButton} onClick={() => setModal_state(true)}>
                        <button>История</button>
                    </div>
                    <div className={styles.containerBet}>

                        <ManualBet styles={styles_wheel} allow_max_bet={true} startBet={null} ButtonsChoiceFastSum={ButtonsChoiceFastSum} setAmount={setAmount} setIndexSelectedButtonsSum={setIndexSelectedButtonsSum} amount={amount} indexSelectedButtonsSum={indexSelectedButtonsSum} />
                        <button className="skeleton-button" style={{ justifyContent: "center" }} disabled={load_buttonBet} onClick={async () => await bet()}>{load_buttonBet ? <Spin /> : <div>Поставить</div>}</button>



                    </div>
                    {/* <div className={styles.containerBetUser}>
                <div className={styles.infoBet}>
                    <div>Вы поставили {formatCurrency(1000, "cost")}</div>
                    
                </div>
            </div> */}
                    {stateBlockWin && (
                        <div className={styles.containerBetUser}>
                            <div className={styles.infoBet}>
                                <div>Ваш процент: {Math.min(100, ((amount + (user_card.amount ? user_card.amount : 0)) / amount_win * 100).toFixed(2))}</div>
                                {amount_win > 0 ? (
                                    <div>Вы заработаете: {formatCurrency(amount_win, "cost")}</div>

                                ) : (
                                    <div></div>
                                )}


                            </div>
                        </div>
                    )}

                    <div className={styles.containerBetUser}>
                        <div className={styles.infoBet} style={{ background: user_card.placement > 0 ? "" : "linear-gradient(315deg, rgb(47, 3, 3) 0%, rgba(243, 132, 132, 0.45) 100%)" }}>
                            {user_card.amount ? (
                                <>

                                    {user_card.placement > 0 ? (
                                        <>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                                <div>Вы поставили: {formatCurrency(user_card.amount, "cost")}</div>
                                                <div>Процент выигрыша: {user_card.percent}%</div>
                                                {user_card.amount_win > 0 ? (
                                                    <div>Вы заработаете: {formatCurrency(user_card.amount_win, "cost")}</div>

                                                ) : (
                                                    <div className={styles.noHaveMebmers}>Пока количество участников меньше 10, проигравших нет.<br/>
                                                        По завершению аукциона вам вернется ваша ставка.</div>
                                                )}

                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>



                                                <div>Всего участников: {users_win.length + users_lose.length}</div>
                                                <div>Ваше место: {user_card.placement}</div>

                                                <div>Общий профит: {formatCurrency(amount_lose, "cost")}</div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div>Вы поставили: {formatCurrency(user_card.amount, "cost")}</div>

                                            <div>Чтобы выиграть, добавьте ставку не менее</div>
                                            <div>{formatCurrency(users_win[users_win.length - 1].amount - (user_card.amount ? user_card.amount : 0) + 1)}</div>
                                        </>

                                    )}

                                </>
                            ) : (
                                <div>Сделайте ставку, чтобы участвовать в аукицоне</div>
                            )}

                        </div>
                    </div>
                    <div className={styles.containerTime}>
                        <p>До конца аукциона:</p>
                        <p className={styles.timeReg}>{formatTime(store.time_auction)}</p>
                    </div>
                </div>
                <div className={styles.wrapper}>
                    <div className={styles.infUsers} style={{ background: "linear-gradient(315deg, rgb(8, 47, 3) 0%, rgba(132, 243, 165, 0.45) 100%)", width: "70%" }}>
                        <div className={styles.headBlock}>Побеждают - {users_win.length}</div>
                        <Table head={
                            <tr>
                                <th>Место</th>
                                <th>Ник</th>
                                <th>Сумма</th>

                                <th>Процент от ставок</th>
                                <th>Будущая прибыль</th>

                            </tr>

                        } body={

                            users_win.map(el => <InfUser amount_lose={amount_lose} status_active={el.user_id === store.user.id} user={el} />)
                        } />
                    </div>
                    <div className={styles.infUsers} style={{ background: "linear-gradient(315deg, rgb(47 3 3) 0%, rgb(243 132 132 / 45%) 100%)", width: "30%" }}>
                        <div className={styles.headBlock}>Проигрывают - {users_lose.length}</div>
                        <Table head={
                            <tr>
                                <th>Место</th>
                                <th>Ник</th>
                                <th>Сумма</th>


                            </tr>

                        } body={users_lose.map(el => <InfUser status_active={el.user_id === store.user.id} user={el} />)} />
                    </div>
                </div>
                
            </div>
            <Footer /> 
            </>
            
        )}






    </>)
}
export default observer(Auction);